import React from "react";
import { get_lang } from "../../global-functions/apiGlobal";
import SaudiRiyalIcon from "../../layout-one/js/assets/images/SaudiRiyalIcon";
import "./storePrice.scss";

/** SAR / AED: currency (or icon) before amount — e.g. SAR 23.000 */
const CURRENCY_FIRST_CODES = ["SAR", "AED"];

const isCurrencyFirst = (storeInfo) =>
  CURRENCY_FIRST_CODES.includes(storeInfo?.currencySymbol);

/**
 * Renders store price with correct order per currency.
 * SAR/AED: currency then amount (SAR 23). Others: amount then currency (23 KWD).
 */
const StorePrice = ({
  amount,
  storeInfo,
  langValue,
  className = "",
  showIcon,
}) => {
  if (storeInfo == null) return null;

  const fixed = storeInfo.numberFixed ?? 3;
  const num = typeof amount === "number" ? amount : parseFloat(amount);
  const value = Number.isFinite(num) ? num.toFixed(fixed) : String(amount ?? "");

  const currencyText = get_lang(storeInfo.storeCurrency, langValue);
  const isRenderableCurrency =
    typeof currencyText === "string" || typeof currencyText === "number";

  const useSarSymbol =
    showIcon !== false &&
    storeInfo.currencySymbol === "SAR" &&
    (storeInfo.currencyIcon || !isRenderableCurrency);

  const useLegacyIcon =
    showIcon !== false &&
    storeInfo.currencyIcon &&
    storeInfo.currencySymbol !== "SAR" &&
    !isRenderableCurrency;

  const currencyFirst = isCurrencyFirst(storeInfo);

  const currencyNode = (
    <span className="storePrice__currency">
      {useSarSymbol ? (
        <SaudiRiyalIcon size={16} className="storePrice__icon" />
      ) : useLegacyIcon ? (
        <img
          src={storeInfo.currencyIcon}
          alt=""
          width={16}
          height={16}
          className="storePrice__icon"
        />
      ) : (
        currencyText
      )}
    </span>
  );

  const valueNode = <span className="storePrice__value">{value}</span>;

  return (
    <span
      className={`storePrice${
        currencyFirst ? " storePrice--currencyFirst" : ""
      } ${className}`.trim()}
      dir="ltr"
    >
      {currencyFirst ? (
        <>
          {currencyNode}
          {valueNode}
        </>
      ) : (
        <>
          {valueNode}
          {currencyNode}
        </>
      )}
    </span>
  );
};

export default StorePrice;
